import { getWindow } from "utils-lib/getWindow"
import { convertUrlQueryParams } from "utils-lib/convertUrlQueryParams"
import { pushToAdobeDataLayer } from "utils-lib/analytics/adobeDataLayer"

const ssrWindow = getWindow()

const GLOBAL_SEARCH = "global-search-query-result-selection"
const SUPPORT_SEARCH = "support-search-query-result-selection"

export const pushQueryResultData = (hit, isSupportPage) => {
  const acdlData = {
    clicks: {
      object_content: {
        searchTerm: ssrWindow.location.search
          ? convertUrlQueryParams(ssrWindow.location.search).q
          : ssrWindow.document
              .getElementById(`full-width-text-field-header`)
              ?.value.toLowerCase(),
        articleName: hit.title,
        siteSearch: isSupportPage ? "Support" : "Global",
        suggestedArticle: "N",
        articleCategory: hit.searchType ? hit.searchType : "Suggested Article",
        articleId: hit.objectID,
        eventName: isSupportPage ? SUPPORT_SEARCH : GLOBAL_SEARCH,
      },
    },
  }

  pushToAdobeDataLayer(isSupportPage ? SUPPORT_SEARCH : GLOBAL_SEARCH, acdlData)
}
